import { render, staticRenderFns } from "./FiltroBaixaTipo.vue?vue&type=template&id=bf921486&"
import script from "./FiltroBaixaTipo.vue?vue&type=script&lang=js&"
export * from "./FiltroBaixaTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf921486')) {
      api.createRecord('bf921486', component.options)
    } else {
      api.reload('bf921486', component.options)
    }
    module.hot.accept("./FiltroBaixaTipo.vue?vue&type=template&id=bf921486&", function () {
      api.rerender('bf921486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Gerenciais/FiltroBaixaTipo.vue"
export default component.exports